import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import shortId from 'shortid';
import DefListColumn from 'components/DefListColumn';
import styles from './styles.css';
import messages from './messages';

const WireDescriptionsPanel = ({
  wireLedgerDescriptions,
  onEditDescriptionsButtonClicked,
  allowEditDescriptions,
}) => (
  <div>
    <div data-test-handle="descriptionPanel__descriptions">
      {wireLedgerDescriptions.map((desc, index) => (
        <DefListColumn
          key={`descriptionPanel__desc${shortId.generate()}`}
          className={styles.defList}
          title={`Description Line ${index + 1}`}
          data={desc}
          dataTestHandle={`descriptionPanel__desc${index}`}
        />
      ))}
    </div>
    {allowEditDescriptions &&
      <button
        bsStyle="link"
        id="#editDescriptions"
        className="button-link btn-pad"
        onClick={onEditDescriptionsButtonClicked}
        data-test-handle="editDescriptionsButton"
      >
        <FormattedMessage {...messages.editDescriptions} />
      </button>
    }
  </div>
);

WireDescriptionsPanel.propTypes = {
  wireLedgerDescriptions: PropTypes.array,
  onEditDescriptionsButtonClicked: PropTypes.func.isRequired,
  allowEditDescriptions: PropTypes.bool.isRequired,
};

WireDescriptionsPanel.defaultProps = {
  wireLedgerDescriptions: ['', '', ''],
};

export default WireDescriptionsPanel;



// WEBPACK FOOTER //
// ./src/components/WireDescriptionsPanel/index.js